import React, { useState } from "react";
import styles from '../index.module.css';
import LoginLogo from '../../../../assets/images/brand/login_logo.png';
import { useDispatch, useSelector } from "react-redux";
import { loginVerificationResend, verificationLogin, verificationResend } from "../../../../redux/features/auth/authService";
import { useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";

const LoginVerification = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isLoginVerificationLoading } = useSelector((state) => state.auth.verifyLoginDetails)
    const { isResendLoginCodeLoading, resendLoginCodeMsg } = useSelector((state) => state.auth.resendLoginCode)

    const [formData, setFormData] = useState({
        verification_code: '',
    });

    const [errorMessages, setErrorMessages] = useState({
        verification_code: '',
    });
    const [resendMsg, setResendMsg] = useState(false);
    const [isFirst, setFirst] = useState(true);
    const [isSecond, setSecond] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
        setResendMsg(false);
    };

    const validateFormData = () => {
        const errors = {};
        if (!formData.verification_code) {
            errors.verification_code = 'Verification Code is required.'
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    }

    const verify = async () => {
        try {
            if (validateFormData()) {
                formData.verification_code = +formData.verification_code;
                const response = await dispatch(verificationLogin(formData)).unwrap();
                if (response.success) {
                    setFirst(false);
                    setSecond(true);
                } else {
                    setErrorMessages({ verification_code: response.message })
                }
            }
        } catch (err) {
            if (err.message == 'Network Error') {
                setErrorMessages({ verification_code: err.message })
            } else {
                setErrorMessages({ verification_code: 'Invalid verification code. Please add the correct verification code.' })
            }
        }
    }

    const directWebsite = async () => {
        navigate('/')
    }


    const resendCode = async () => {
        setErrorMessages({
            verification_code: ''
        });
        setResendMsg(true);
        dispatch(loginVerificationResend());
    }

    return (
        <div className={styles.authContainer}>
            {isFirst &&
                <div className={styles.authCard}>
                    <div className={styles.authCardHeader}>
                        <img src={LoginLogo} alt="Logo" className={styles.logoImg} />
                        <h1 className={styles.authTitle} style={{ marginBottom: '15px' }}>Enter Verification Code</h1>
                        <div className={styles.subTitleRow}>
                            <p>We've sent a verification code to the email assosiated with your account. Please enter the code below to verify your email. <span className={styles.loginLink} onClick={resendCode}>Resend code</span></p>
                        </div>
                    </div>
                    <div className={styles.authCardBody}>
                        <div className={styles.formContainer}>
                            <form noValidate>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Verification Code
                                        </label>
                                        <input
                                            type='text'
                                            id='verification_code'
                                            name='verification_code'
                                            value={formData.verification_code}
                                            onChange={handleInputChange}
                                            placeholder='Enter code'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.verification_code && (
                                            <p className={`text-danger`}>{errorMessages.verification_code}</p>
                                        )}
                                        {!errorMessages.verification_code && resendLoginCodeMsg && resendMsg && <p className={`text-success`}>Verification email sent successfully. Please check your inbox.</p>}
                                    </div>
                                </div>
                                <button
                                    className={styles.authBtn}
                                    type='button'
                                    disabled={isLoginVerificationLoading}
                                    onClick={verify}
                                >
                                    {isLoginVerificationLoading ? <BeatLoader color='#ffffff' /> : `Verify`}
                                </button>
                            </form>
                        </div>
                    </div>
                </div >
            }
            {isSecond &&
                <div className={styles.authCard}>
                    <div className={styles.authCardHeader}>
                        <img src={LoginLogo} alt="Logo" className={styles.logoImg} />
                        <h1 className={styles.authTitle} style={{ marginBottom: '15px' }}>Verification Successful!</h1>
                        <div className={styles.subTitleRow}>
                            <p>You have successfully verified your account</p>
                        </div>
                    </div>
                    <div className={styles.authCardBody}>
                        <div className={styles.formContainer}>
                            <form noValidate>
                                <button
                                    className={styles.authBtn}
                                    type='button'
                                    onClick={directWebsite}
                                >
                                    Go to our Website
                                </button>
                            </form>
                        </div>
                    </div>
                </div >
            }
        </div >
    )
}

export default LoginVerification;